export enum Alignment {
    Left = 'left',
    Center = 'center',
    Right = 'right'
}

export enum TextColor {
    Black = 'black',
    White = 'white'
}
